import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  CardActionArea,
  Theme,
} from '@quillbot/design-system';
import { WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';
import Link from 'next/link';

interface Member {
  name: string;
  imgPath: string;
  designation: string | JSX.Element;
}

const teamMembers: Member[] = [
  {
    name: 'Anil Jason',
    imgPath: 'images/misc/jaybot.png',
    designation: 'Co-founder & CTO',
  },
  {
    name: 'Rohan Gupta',
    imgPath: 'images/misc/rohbot.png',
    designation: 'Co-founder & CEO',
  },
  {
    name: 'Dave Silin',
    imgPath: 'images/misc/dave.png',
    designation: 'Co-founder & CSO',
  },
  {
    name: 'Saurabh Goel',
    imgPath: 'images/misc/saurabh.png',
    designation: 'Director of Engineering',
  },
  {
    name: 'Nikhil Agrawal',
    imgPath: 'images/misc/nikhil.png',
    designation: 'Senior Technical Lead',
  },
  {
    name: 'Andy Schultz',
    imgPath: 'images/misc/andy.png',
    designation: 'Director of Design',
  },
  {
    name: 'Nick Chlumecky',
    imgPath: 'images/misc/nick.png',
    designation: 'Operations Analyst',
  },
  {
    name: 'Aman Murjani',
    imgPath: 'images/misc/aman.png',
    designation: 'Head of HR',
  },
  {
    name: 'Kaivan Dave',
    imgPath: 'images/misc/kaiven.png',
    designation: 'Director of Marketing',
  },
  {
    name: 'Aashis Kumar',
    imgPath: 'images/misc/aashis.png',
    designation: 'DevOps Engineer',
  },
  {
    name: 'Dr. Brendan Chambers',
    imgPath: 'images/misc/Brendan.svg',
    designation: 'Applied Research Scientist',
  },
  {
    name: 'Prem Serawat',
    imgPath: 'images/misc/Prem.svg',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Siddharth Jaidka',
    imgPath: '/images/misc/siddarth.png',
    designation: 'Senior Full Stack Engineer',
  },
  {
    name: 'Ganesh Patel',
    imgPath: '/images/misc/ganesh.png',
    designation: 'Senior Research Engineer',
  },
  {
    name: 'Manmohan Sharma',
    imgPath: '/images/misc/Manmohan.png',
    designation: 'Quality Assurance Lead',
  },
  {
    name: 'Abhishek Agarwal',
    imgPath: '/images/misc/abhishek.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Mike Foster',
    imgPath: '/images/misc/mike.png',
    designation: 'Sr. Computational Linguist',
  },
  {
    name: 'Dr. Emily Perry',
    imgPath: '/images/misc/emily.png',
    designation: 'Senior Education Program Manager',
  },
  {
    name: 'Dr. Kevin Gimpel',
    imgPath: '/images/misc/Gimpel.png',
    designation: 'Senior Director of Research',
  },
  {
    name: 'Atul Agarwal',
    imgPath: '/images/misc/atul.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'V Varshith',
    imgPath: '/images/misc/varshith.png',
    designation: 'Research Engineer',
  },
  {
    name: 'Ravi Semwal',
    imgPath: '/images/misc/Ravi.png',
    designation: 'Technical Lead',
  },
  {
    name: 'Vrinda Shrivastava',
    imgPath: '/images/misc/Vrinda.png',
    designation: 'Operations Executive',
  },
  {
    name: 'Aniket Jha',
    imgPath: '/images/misc/Aniket.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Akash Kumar',
    imgPath: '/images/misc/akash.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Rajat Kaushik',
    imgPath: '/images/misc/Rajat.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Abhishek Shekhawat',
    imgPath: '/images/misc/abhishek_S.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Manpreet Kaur',
    imgPath: '/images/misc/manpreet.png',
    designation: 'HR Specialist',
  },
  {
    name: 'Harsh Harsola',
    imgPath: '/images/misc/Harsh.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Asif Jamil',
    imgPath: '/images/misc/Asif.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Nitika Agarwal',
    imgPath: '/images/misc/Nitika.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Mukul P',
    imgPath: '/images/misc/Mukul.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Anshumaan Sahu',
    imgPath: '/images/misc/Anshumaan.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Pramod Kumar',
    imgPath: '/images/misc/Pramod.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Sanhita Agarwal',
    imgPath: '/images/misc/Sanhita.png',
    designation: 'Head of SEO',
  },
  {
    name: 'Krishna Rao',
    imgPath: '/images/misc/Krishna.png',
    designation: 'Senior Engineering Manager',
  },
  {
    name: 'Sourav Das',
    imgPath: '/images/misc/Sourav.png',
    designation: 'Experience Designer',
  },
  {
    name: 'Amy Kanzleiter',
    imgPath: '/images/misc/Amy.png',
    designation: 'Controller',
  },
  {
    name: 'Jen Vaughan',
    imgPath: '/images/misc/Jen.png',
    designation: 'Fractional CFO',
  },
  {
    name: 'Marine Asalia',
    imgPath: '/images/misc/Marine.png',
    designation: 'Engineering Manager',
  },
  {
    name: 'Ashimma Goyl',
    imgPath: '/images/misc/ashimma.png',
    designation: 'Manager - Finance and Accounts',
  },
  {
    name: 'Gulsaba Khan',
    imgPath: '/images/misc/Gulsaba.png',
    designation: 'Manager - Business Development',
  },
  {
    name: 'Paige Pfeifer',
    imgPath: '/images/misc/Paige.png',
    designation: 'Communications Manager',
  },
  {
    name: 'Mayukh Rath',
    imgPath: '/images/misc/Mayukh.png',
    designation: 'Research Scientist',
  },
  {
    name: 'Deepak Kewlani',
    imgPath: '/images/misc/Deepak.png',
    designation: 'Marketing Coordinator',
  },
  {
    name: 'Sourya Gupta',
    imgPath: '/images/misc/Sourya.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Kajal Khandelwal',
    imgPath: '/images/misc/Kajal.png',
    designation: 'Operations Executive',
  },
  {
    name: 'Peri Oxford',
    imgPath: '/images/misc/Peri.png',
    designation: 'Computational Linguist',
  },
  {
    name: 'Japneet Singh',
    imgPath: '/images/misc/Jerry.png',
    designation: 'Experience Designer',
  },
  {
    name: 'Avayam Bhardwaj',
    imgPath: '/images/misc/Avayam.png',
    designation: 'Manager - Administration',
  },
  {
    name: 'Devashish Kureel',
    imgPath: '/images/misc/Devashish.png',
    designation: 'Senior DevOps Engineer',
  },
  {
    name: 'Himanshu Grover',
    imgPath: '/images/misc/Himanshu.png',
    designation: 'UI Developer',
  },
  {
    name: 'Ashish',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Somiya Garg',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'HR Specialist',
  },
  {
    name: 'Samarth Agarwal',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior Full Stack Engineer',
  },
  {
    name: 'Vibha Shenoy',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Quality Assurance Engineer',
  },
  {
    name: 'Anshul Bisen',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior Full Stack Engineer',
  },
  {
    name: 'Bhavya Bandi',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior Quality Assurance Engineer',
  },
  {
    name: 'Rajendra Kumar',
    imgPath: '/images/misc/Rajendra.png',
    designation: 'Senior Quality Assurance Engineer',
  },
  {
    name: 'Vibhu Banka',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Vishal Bhadauria',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior Quality Assurance Engineer',
  },
  {
    name: 'Gaurav Sawlani',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Operations Executive',
  },
  {
    name: 'Nirjhar Banik',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior Quality Assurance Engineer',
  },
  {
    name: 'Shubham Sharma',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Suraj Sharma',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Rocky Sharma',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior Quality Assurance Engineer',
  },
  {
    name: 'Vivek Radhakrishnan',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Creative Lead',
  },
  {
    name: 'Damanjot Singh',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior Paid Media Specialist',
  },
  {
    name: 'Kumar Prince',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior Quality Assurance Engineer',
  },
  {
    name: 'Asad Dhamani',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Ashi Agrawal',
    imgPath: '/images/misc/Ashi.png',
    designation: 'Data Engineer',
  },
  {
    name: 'Amit Chaurasia',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Principal Software Development Engineer',
  },
  {
    name: 'Kaif Bhati',
    imgPath: '/images/misc/Kaif.png',
    designation: 'SEO Specialist',
  },
  {
    name: 'Vishal Kumar',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior Full Stack Engineer',
  },
  {
    name: 'Vijaya Laxmi',
    imgPath: '/images/misc/Vijaya.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Navya Natani',
    imgPath: '/images/misc/Navya.png',
    designation: 'Marketing Coordinator',
  },
  {
    name: 'Preyansh Mitharwal',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Renata Sandoval',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Influencer Marketing Specialist',
  },
  {
    name: 'Roopesh Donde',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior UX/UI Designer',
  },
  {
    name: 'Aman Jain',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Business Development Specialist',
  },
  {
    name: 'Prateek Saxena',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Research Engineer',
  },
  {
    name: 'Roopa B',
    imgPath: '/images/misc/Roopa.png',
    designation: 'Senior People and Culture Specialist',
  },
  {
    name: 'Charu Ramchandani',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Operations Executive',
  },
  {
    name: 'Shweta Apte',
    imgPath: '/images/misc/Shweta.png',
    designation: 'UX Researcher',
  },
  {
    name: 'Prajkta Khapre',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Operations Executive',
  },
  {
    name: 'Nabeel Thurakkal',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Senior UI Developer',
  },
  {
    name: 'Julia M. Jennings',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Analytical Linguist',
  },
  {
    name: 'Yashika Saluja',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Executive - Finance and Accounts',
  },
  {
    name: 'Adhikansh Singh',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Aayush Agrawal',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Sagar Pamnani',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Operations Executive',
  },
  {
    name: 'Ashish Ingle',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Multimedia Specialist',
  },
  {
    name: 'Vinod Kandpal',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Full Stack Engineer',
  },
  {
    name: 'Annabel Grossman',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Growth Marketing Associate',
  },
  {
    name: 'Varsha Mothukuri',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Quality Assurance Engineer',
  },
  {
    name: 'Samiksha Patil',
    imgPath: '/images/misc/quill_wave.png',
    designation: 'Human Resources Specialist',
  },
  {
    name: 'You',
    imgPath: '/images/misc/quill_wave.png',
    designation: (
      <Link href="/careers">
        <a target="_blank" style={{ textAlign: 'center' }} className="btn-link">
          Join Us!
        </a>
      </Link>
    ),
  },
];

const styles = (theme: Theme) =>
  createStyles({
    media: {
      backgroundSize: 'contain',
    },
    img: {
      height: '140px',
    },

    teamCardBox: {},
    content: {
      textAlign: 'center' as const,
      padding: 5,
    },
    cardArea: {
      cursor: 'default',
    },
    aboutBodyContainer: {
      left: 0,
      top: '60px',
      width: '100%',
      marginBottom: '50px',
      [theme.breakpoints.down('sm')]: {
        marginTop: 50,
      },
    },
    qbpFSize35: {
      fontSize: '35px !important',
    },
  });

function ProfileCard(props: Member & WithStyles<typeof styles>) {
  const { classes } = props;
  return (
    <Grid
      container
      item
      lg={3}
      md={4}
      sm={6}
      xs={12}
      /* justify="center" */
    >
      <CardActionArea>
        <Card elevation={0} className={classes.teamCardBox}>
          <CardMedia
            className={classes.media}
            image={props.imgPath}
            classes={{ root: classes.img }}
            title=""
          />
          <CardContent className={classes.content}>
            <Typography gutterBottom variant="h5" component="h2" style={{ fontSize: '20px' }}>
              {props.name}
            </Typography>
            <Typography variant="body1" color="textSecondary" component="p">
              {props.designation}
            </Typography>
          </CardContent>
        </Card>
      </CardActionArea>
    </Grid>
  );
}

function About(props: WithStyles<typeof styles>) {
  const { classes } = props;
  return (
    <div className="container">
      <Grid container justifyContent="center">
        <Grid item md={12} xs={12}>
          <div className={classes.aboutBodyContainer}>
            <Grid
              container
              justifyContent="center"
              spacing={2}
              /*  style={{ color: '#4f4f4f' }} */
            >
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <h1 className="pageTitle">Transforming the way you write</h1>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  /* color="textPrimary" */
                  display="block"
                  gutterBottom
                  style={{ maxWidth: '670px', margin: 'auto', textAlign: 'center' }}
                >
                  QuillBot&apos;s suite of tools employs cutting-edge AI technology in order to make
                  writing painless. Founded on the belief that learning and applying knowledge is
                  more important than the mechanical aspects of writing, QuillBot seeks to automate
                  these necessary tasks intending to augment your language. Now, you can focus on
                  what you write, not how you should write it.
                </Typography>
              </Grid>
            </Grid>
            <Grid container justifyContent="center" spacing={3}>
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <h1 className="pageTitle">Our Team</h1>
              </Grid>
            </Grid>
            <Grid container justifyContent="center" spacing={3} style={{ paddingBottom: '76px' }}>
              {teamMembers.map((member) => (
                <ProfileCard {...member} classes={classes} key={member.name} />
              ))}
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(About);
